import AnalysisRepository from "./AnalysisRepository";
import AnalyteRepository from "./AnalyteRepository";
import AnalyteRangeRepository from "./AnalyteRangeRepository";
import AnalyteResultRepository from "./AnalyteResultRepository";
import AttributeListsRepository from "./AttributeListsRepository";
import InstrumentInstanceExportRepository from "./InstrumentInstanceExportRepository";
import InstrumentInstanceImportRepository from "./InstrumentInstanceImportRepository";
import InstrumentInstanceRepository from "./InstrumentInstanceRepository";
import InstrumentInstanceSchedulesRepository from "./InstrumentInstanceSchedulesRepository";
import InstrumentJigRepository from "./InstrumentJigRepository";
import InstrumentRepository from "./InstrumentRepository";
import LaboratoryRepository from "./LaboratoryRepository";
import ManagedListsRepository from "./ManagedListRepository";
import MeasureUnitsRepository from "./MeasureUnitsRepository";
import NoteRepository from "./NoteRepository";
import PrepProcessRepository from "./PrepProcessRepository";
import PrepTaskRepository from "./PrepTaskRepository";
import PrepWorkflowRepository from "./PrepWorkflowRepository";
import ProcessScheduleRepository from "./ProcessScheduleRepository";
import ProjectRepository from "./ProjectRepository";
import SampleRepository from "./SampleRepository";
import SampleTypeRepository from "./SampleTypeRepository";
import ServiceInstructionRepository from "./ServiceInstructionRepository";
import ServiceQuestionRepository from "./ServiceQuestionRepository";
import ScheduleRepository from "./ScheduleRepository";
import StaffRepository from "./StaffRepository";
import SubmissionRepository from "./SubmissionRepository";
import TestPackageGroupRepository from "./TestPackageGroupRepository";
import TestPackageRepository from "./TestPackageRepository";
import TestPackageSampleRepository from "./TestPackageSampleRepository";
import TestProcessRepository from "./TestProcessRepository";
import TestTaskRepository from "./TestTaskRepository";
import TestWorkflowRepository from "./TestWorkflowRepository";
import TurnaroundRepository from "./TurnaroundRepository";
import WorkGroupRepository from "./WorkGroupRepository";
import ResultExportRepository from "./ResultExportRepository";
import ResultImportRepository from "./ResultImportRepository";
import QualityControlRepository from "./QualityControlRepository";

const repositories = {
  analysis: AnalysisRepository,
  analyte: AnalyteRepository,
  analyteRange: AnalyteRangeRepository,
  analyteResult: AnalyteResultRepository,
  attributeLists: AttributeListsRepository,
  instrument: InstrumentRepository,
  instrumentInstance: InstrumentInstanceRepository,
  instrumentInstanceExport: InstrumentInstanceExportRepository,
  instrumentInstanceImport: InstrumentInstanceImportRepository,
  instrumentInstanceSchedules: InstrumentInstanceSchedulesRepository,
  instrumentJig: InstrumentJigRepository,
  laboratory: LaboratoryRepository,
  managedLists: ManagedListsRepository,
  measure: MeasureUnitsRepository,
  note: NoteRepository,
  prepProcess: PrepProcessRepository,
  prepTask: PrepTaskRepository,
  prepWorkflow: PrepWorkflowRepository,
  processSchedule: ProcessScheduleRepository,
  project: ProjectRepository,
  qualityControl: QualityControlRepository,
  resultExport: ResultExportRepository,
  resultImport: ResultImportRepository,
  sample: SampleRepository,
  sampleType: SampleTypeRepository,
  schedule: ScheduleRepository,
  serviceQuestion: ServiceQuestionRepository,
  serviceInstruction: ServiceInstructionRepository,
  staff: StaffRepository,
  submission: SubmissionRepository,
  testPackage: TestPackageRepository,
  testPackageGroup: TestPackageGroupRepository,
  testPackageSample: TestPackageSampleRepository,
  testProcess: TestProcessRepository,
  testTask: TestTaskRepository,
  testWorkflow: TestWorkflowRepository,
  turnaround: TurnaroundRepository,
  workGroup: WorkGroupRepository,
};

export const LabRepositoryFactory = {
  get: name => repositories[name]
};
